<template>
    <footer class="wow animate__animated animate__fadeInRightBig">
        <div class="footer-content">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <img src="../assets/img/shield-fresto.svg" width="85" class="d-block m-auto" alt="">
                    </div>
                </div>

                <div class="row d-flex align-items-end py-5">
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <ul class="footer-list">
                            <li>
                                <router-link to="/contato" class="footer-link">Fale Conosco</router-link>
                            </li>
                            <li>
                                <router-link to="/delivery" class="footer-link">Delivery</router-link>
                            </li>
                            <li>
                                <router-link to="/trabalhe-conosco" class="footer-link">Entre para o nosso time</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <ul class="footer-list">
                            <li>
                                <router-link to="/conheca-fresto" class="footer-link">Conheça o Fresto</router-link>
                            </li>
                            <li>
                                <a href="#unidades" class="footer-link">Unidades</a>
                            </li>
                            <li>
                                <router-link to="/eventos" class="footer-link">Eventos</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">

                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <p class="footer-text gap-3">
                            Siga nossas redes: 
                            <a href="https://www.instagram.com/frestofood/" class="footer-rs" target="_blank">
                                <img src="../assets/img/footer/rs-instagram.svg" width="32" height="32" class="mx-1" alt="Intagram @frestofood">
                            </a>

                            <a href="https://www.facebook.com/FrestoFood/" class="footer-rs" target="_blank">
                                <img src="../assets/img/footer/rs-facebook.svg" width="32" height="32" class="mx-1" alt="Facebook.com/frestofood">
                            </a>
                        </p>
                    </div>
                </div>

            </div>
        </div>
        
        <div class="copyright">
            <div class="container">
                <div class="copyright-content py-3">
                    <p>Copyright © 2024. Fresto. Todos os direitos reservados. <router-link to="/politicas-privacidade">Políticas de Privacidade</router-link></p>
                    
                    <p>
                        <a href="https://falopes.com.br/" target="_blank">
                            <img src="../assets/img/footer/falopes.svg" alt="Falopes Tecnologia">
                        </a>
                    </p>                    
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterComponent',
};
</script>

<style scoped>
/* Adicione aqui os estilos específicos do footer, se necessário */
</style>
